export default __webpack_public_path__ + "static/media/86_mobile.764cb7ee.jpg";